import { render, staticRenderFns } from "./QuestionCrosswiseBlank.vue?vue&type=template&id=b80508ec&scoped=true&"
import script from "./QuestionCrosswiseBlank.vue?vue&type=script&lang=js&"
export * from "./QuestionCrosswiseBlank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCrosswiseBlank.vue?vue&type=style&index=0&id=b80508ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80508ec",
  null
  
)

export default component.exports